import {dedupingMixin} from "@polymer/polymer/lib/utils/mixin";
import {afterNextRender} from '@polymer/polymer/lib/utils/render-status.js';

/**
 * @polymer
 * @mixinFunction
 **/
export const DraggableBehavior = dedupingMixin((superClass) => class extends superClass {
  static get properties() {
    return {
      _draggableLibrary: Object,
      _draggablePosition: Object,
      draggableContainmentElement: Object,
      draggableEnabled: {type: Boolean, value: true},
      draggableEndHandler: Object,
      draggableFuzzyContainment: Object,
      draggableHandleElement: {type: Array, observer: 'draggableHandleElementChanged'},
      draggableIsDragging: Boolean,
      draggableIsDraggingClass: {type: String, value: 'is-dragging'},
      draggableMoveHandler: Object,
      draggableStartHandler: Object
    };
  }

  connectedCallback() {
    super.connectedCallback();
    this._draggableLibrary = window.displacejs(this, {
      onMouseDown: this.draggableHandleStart.bind(this),
      onTouchStart: this.draggableHandleStart.bind(this),
      onMouseUp: this.draggableHandleEnd.bind(this),
      onTouchStop: this.draggableHandleEnd.bind(this),
      customMove: this.draggableHandleMove.bind(this)
    });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this._draggableLibrary.destroy();
    this._draggableLibrary = null;

    this.draggableContainmentElement = null;
    this.draggableHandleElement = null;
  }

  draggableHandleElementChanged(newValue) {
    if (newValue) {
      this._draggableLibrary.opts.handle = newValue;
    }
    this._draggableLibrary?.reinit();
  }

  draggableHandleStart(element) {
    if (!this.draggableEnabled) {
      return;
    }
    this._draggablePosition = {
      top: element.offsetTop,
      left: element.offsetLeft,
      width: element.offsetWidth,
      height: element.offsetHeight,
      containerWidth: (this.draggableContainmentElement ? this.draggableContainmentElement.offsetWidth : null),
      containerHeight: (this.draggableContainmentElement ? this.draggableContainmentElement.offsetHeight : null)
    };
  }

  draggableHandleMove(element, x, y) {
    if (!this.draggableEnabled || !this._draggablePosition) {
      return;
    }

    if (!this.draggableIsDragging) {
      this.draggableIsDragging = true;
      this.classList.add(this.draggableIsDraggingClass);

      if (this.draggableStartHandler) {
        this.draggableStartHandler(this._draggablePosition, event);
      }
    }

    if (this.draggableContainmentElement) {
      let containmentBoxTop = 0;
      let containmentBoxRight = this._draggablePosition.containerWidth;
      let containmentBoxBottom = this._draggablePosition.containerHeight;
      let containmentBoxLeft = 0;
      if (this.draggableFuzzyContainment) {
        containmentBoxRight += (this._draggablePosition.width - this.draggableFuzzyContainment.right);
        containmentBoxBottom += (this._draggablePosition.height - this.draggableFuzzyContainment.bottom);
        containmentBoxLeft -= (this._draggablePosition.width - this.draggableFuzzyContainment.left);
      }
      if (x < containmentBoxLeft) {
        x = containmentBoxLeft;
      } else if ((x + this._draggablePosition.width) > containmentBoxRight) {
        x = containmentBoxRight - this._draggablePosition.width;
      }
      if (y < containmentBoxTop) {
        y = containmentBoxTop;
      } else if ((y + this._draggablePosition.height) > containmentBoxBottom) {
        y = containmentBoxBottom - this._draggablePosition.height;
      }
    }

    let left = x - this._draggablePosition.left;
    let top = y - this._draggablePosition.top;
    this._draggablePosition.newX = x;
    this._draggablePosition.newY = y;
    this.style.transform = `translate3d(${left}px, ${top}px, 0)`;

    if (this.draggableMoveHandler) {
      this.draggableMoveHandler(this._draggablePosition);
    }
  }

  draggableHandleEnd() {
    if (!this.draggableEnabled || !this.draggableIsDragging || !this._draggablePosition) {
      return;
    }
    this.draggableIsDragging = false;

    this.style.transform = '';
    this.style.top = `${this._draggablePosition.newY}px`;
    this.style.left = `${this._draggablePosition.newX}px`;

    if (this.draggableEndHandler) {
      this.draggableEndHandler(this._draggablePosition);
    }
    this._draggablePosition = undefined;
    afterNextRender(this, () => {
      this.classList.remove(this.draggableIsDraggingClass);
    });
  }
});